import { render, staticRenderFns } from "./kingdomz.vue?vue&type=template&id=2144dab0&scoped=true"
import script from "./kingdomz.vue?vue&type=script&lang=js"
export * from "./kingdomz.vue?vue&type=script&lang=js"
import style0 from "./kingdomz.vue?vue&type=style&index=0&id=2144dab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2144dab0",
  null
  
)

export default component.exports